import {
  ActionIcon,
  Avatar,
  Badge,
  Card,
  Group,
  Progress,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconQrcode, IconTrash } from "@tabler/icons-react";

const GiveawaySponsorCard = ({
  sponsor,
  totalParticipants,
  handleOpenSponsorQRCodeModal,
  isDisabled,
  qrDisabled,
  handleRemoveSponsor,
}) => {
  const removeLabel = isDisabled
    ? "Cannot remove sponsor if giveaway is live or if there are already scans"
    : "Remove sponsor from giveaway";

  return (
    <Card withBorder padding="md" radius="md">
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group wrap="nowrap" style={{ flex: 1 }}>
          <Avatar
            src={sponsor.logo}
            radius="md"
            size="xl"
            variant="light"
            imageProps={{ crossOrigin: "anonymous" }}
          >
            {sponsor.name?.[0]}
          </Avatar>
          <Stack gap="xs" flex={1}>
            <Text
              size="md"
              fw={600}
              style={{ flex: 1, wordBreak: "break-word" }}
            >
              {sponsor.name}
            </Text>
            <Badge size="md" variant="light" color="green" radius="sm">
              {sponsor.levelName || "Sponsor"}
            </Badge>
            <Tooltip
              label={`${sponsor.scanCount} scans out of ${totalParticipants} participants`}
            >
              <Group
                gap="sm"
                wrap="nowrap"
                style={{ width: "50%", minWidth: 150 }}
              >
                <Progress
                  value={
                    totalParticipants > 0
                      ? (sponsor.scanCount / totalParticipants) * 100
                      : 0
                  }
                  size="md"
                  radius="xl"
                  color="green"
                  style={{ flex: 1 }}
                />
                <Text
                  size="xs"
                  c="dimmed"
                  fw={600}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {sponsor.scanCount}
                </Text>
              </Group>
            </Tooltip>
          </Stack>
        </Group>
        <Group wrap="nowrap" gap="xs">
          <Tooltip label="Sponsor QR code">
            <ActionIcon
              color="green"
              variant="light"
              size="lg"
              disabled={qrDisabled}
              onClick={() => handleOpenSponsorQRCodeModal(sponsor)}
              style={{ flexShrink: 0 }}
            >
              <IconQrcode size={24} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label={removeLabel}>
            <ActionIcon
              color="red"
              variant="light"
              disabled={isDisabled}
              onClick={() => handleRemoveSponsor(sponsor.id)}
              style={{ flexShrink: 0 }}
              size="lg"
            >
              <IconTrash size={24} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Group>
    </Card>
  );
};

export default GiveawaySponsorCard;
